import Text from '@/components/elements/Text';
import { useStore } from '@/lib/store';

export default function SocialMedia({ color = 'white' }) {
  const { footerData } = useStore((state) => ({
    footerData: state.footerData,
  }));
  return (
    <>
      {footerData && (
        <div className="flex gap-4">
          {footerData?.socialFacebook.url && (
            <a
              href={footerData?.socialFacebook.url}
              className="inline-block duration-200 hover:scale-105 hover:opacity-70"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20ZM22.0846 31.7596V20.8785H25.0883L25.4863 17.1288H22.0846L22.0897 15.2521C22.0897 14.2741 22.1827 13.7501 23.5873 13.7501H25.4651V10H22.461C18.8526 10 17.5826 11.819 17.5826 14.878V17.1293H15.3333V20.8789H17.5826V31.7596H22.0846Z"
                  fill={color}
                />
              </svg>
            </a>
          )}
          {footerData?.socialTwitter.url && (
            <a
              href={footerData?.socialTwitter.url}
              className="inline-block duration-200 hover:scale-105 hover:opacity-70"
            >
              <Text color="inherit" element="span">
                Twitter
              </Text>
            </a>
          )}
          {footerData?.socialInstagram.url && (
            <a
              href={footerData?.socialInstagram.url}
              className="inline-block duration-200 hover:scale-105 hover:opacity-70"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0ZM13.617 10.094H26.3843C28.3295 10.094 29.9063 11.6709 29.9063 13.616V26.3833C29.9063 28.3285 28.3295 29.9053 26.3843 29.9053H13.617C11.6719 29.9053 10.095 28.3285 10.095 26.3833V13.616C10.095 11.6709 11.6719 10.094 13.617 10.094ZM8.33398 13.616C8.33398 10.6983 10.6993 8.33301 13.617 8.33301H26.3843C29.302 8.33301 31.6673 10.6983 31.6673 13.616V26.3833C31.6673 29.3011 29.302 31.6663 26.3843 31.6663H13.617C10.6993 31.6663 8.33398 29.3011 8.33398 26.3833V13.616ZM20.0036 24.2762C22.3652 24.2762 24.2796 22.3618 24.2796 20.0002C24.2796 17.6386 22.3652 15.7242 20.0036 15.7242C17.642 15.7242 15.7276 17.6386 15.7276 20.0002C15.7276 22.3618 17.642 24.2762 20.0036 24.2762ZM20.0036 26.1767C23.4148 26.1767 26.1801 23.4114 26.1801 20.0002C26.1801 16.589 23.4148 13.8237 20.0036 13.8237C16.5924 13.8237 13.8271 16.589 13.8271 20.0002C13.8271 23.4114 16.5924 26.1767 20.0036 26.1767ZM26.1753 15.1968C25.4173 15.1968 24.8028 14.5822 24.8028 13.8242C24.8028 13.0662 25.4173 12.4517 26.1753 12.4517C26.9333 12.4517 27.5479 13.0662 27.5479 13.8242C27.5479 14.5822 26.9333 15.1968 26.1753 15.1968Z"
                  fill={color}
                />
              </svg>
            </a>
          )}
          {footerData?.socialClutch.url && (
            <a
              href={footerData?.socialClutch.url}
              className="inline-block duration-200 hover:scale-105 hover:opacity-70"
            >
              <Text color="inherit" element="span">
                Clutch
              </Text>
            </a>
          )}
          {footerData?.socialLinkedIn.url && (
            <a
              href={footerData?.socialLinkedIn.url}
              className="inline-block duration-200 hover:scale-105 hover:opacity-70"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20ZM14.1338 16.5648H9.6014V30.1829H14.1338V16.5648ZM14.4322 12.3522C14.4028 11.017 13.448 10 11.8974 10C10.3469 10 9.33325 11.017 9.33325 12.3522C9.33325 13.6598 10.317 14.7061 11.8386 14.7061H11.8676C13.448 14.7061 14.4322 13.6598 14.4322 12.3522ZM30.4795 22.3748C30.4795 18.1919 28.2435 16.2451 25.2609 16.2451C22.8545 16.2451 21.7771 17.5669 21.1755 18.4941V16.5652H16.6425C16.7023 17.8431 16.6425 30.1833 16.6425 30.1833H21.1755V22.5779C21.1755 22.1709 21.2049 21.7648 21.3248 21.4734C21.6524 20.6604 22.3982 19.8185 23.6504 19.8185C25.2911 19.8185 25.947 21.0673 25.947 22.8973V30.183H30.4793L30.4795 22.3748Z"
                  fill={color}
                />
              </svg>
            </a>
          )}
        </div>
      )}
    </>
  );
}
